import { AnyAction } from 'redux';
import { RootDispatch } from 'store/types';
import { KEY } from '../types';
import { normalizeStorage } from './mappers';
import * as types from './types';

export const HYDRATE = `${KEY}.HYDRATE`;
export const HYDRATE_SUCCESS = `${KEY}.HYDRATE_SUCCESS`;
export const HYDRATE_FAIL = `${KEY}.HYDRATE_FAIL`;

export const hydrate = <T>(payload: types.HydratePayload<T>) => ({
  type: HYDRATE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'hydrate',
      data: payload
    }
  }
});

export const SET_STORAGE = `${KEY}.SET_STORAGE`;
export const SET_STORAGE_SUCCESS = `${KEY}.SET_STORAGE_SUCCESS`;
export const SET_STORAGE_FAIL = `${KEY}.SET_STORAGE_FAIL`;

export const setStorage = <T>(payload: types.SetStoragePayload<T>) => ({
  type: SET_STORAGE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'set',
      data: payload
    }
  }
});

export const REMOVE_STORAGE = `${KEY}.REMOVE_STORAGE`;
export const REMOVE_STORAGE_SUCCESS = `${KEY}.REMOVE_STORAGE_SUCCESS`;
export const REMOVE_STORAGE_FAIL = `${KEY}.REMOVE_STORAGE_FAIL`;

export const removeStorage = (payload: types.RemoveStoragePayload) => ({
  type: REMOVE_STORAGE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'remove',
      data: payload
    }
  }
});

export const GET_STORAGE = `${KEY}.GET_STORAGE`;
export const GET_STORAGE_SUCCESS = `${KEY}.GET_STORAGE_SUCCESS`;
export const GET_STORAGE_FAIL = `${KEY}.GET_STORAGE_FAIL`;

export const getStorage = () => async (dispatch: RootDispatch) => {
  dispatch({ type: GET_STORAGE });

  const response: AnyAction = await dispatch({
    type: GET_STORAGE,
    payload: {
      client: 'amwell',
      request: {
        resourceName: 'get'
      }
    }
  });

  if (response.error) {
    dispatch({ type: GET_STORAGE_FAIL, error: response.error });
  } else {
    const payload = normalizeStorage(response.payload);
    dispatch({ type: GET_STORAGE_SUCCESS, payload });
  }
};

export const CLEAR_STORAGE = `${KEY}.CLEAR_STORAGE`;
export const CLEAR_STORAGE_SUCCESS = `${KEY}.CLEAR_STORAGE_SUCCESS`;
export const CLEAR_STORAGE_FAIL = `${KEY}.CLEAR_STORAGE_FAIL`;

export const clearStorage = (payload: types.ClearStoragePayload = { opts: 'all' }) => ({
  type: CLEAR_STORAGE,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'clear',
      data: payload
    }
  }
});
